"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Attachment = _interopRequireDefault(require("./Attachment"));

var _utils = require("./utils");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var AttachmentList = function AttachmentList(_ref) {
  var _ref$attachments = _ref.attachments,
      attachments = _ref$attachments === void 0 ? [] : _ref$attachments,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? [] : _ref$errors,
      _onDelete = _ref.onDelete,
      onDismissError = _ref.onDismissError;

  if (!attachments.length && !errors.length) {
    return null;
  }

  attachments = (0, _utils.normalizeAttachments)(attachments);
  return (0, _preact.h)("div", {
    className: "content-attachments"
  }, Boolean(errors.length) && (0, _preact.h)("p", {
    className: "content-attachments__error"
  }, (0, _preact.h)("span", null, errors.map(function (_ref2) {
    var filename = _ref2.filename,
        errorPhrase = _ref2.errorPhrase,
        allowedFilesSize = _ref2.allowedFilesSize;

    var phraseParams = _objectSpread(_objectSpread({}, _utils.allowedFilesError), {}, {
      allowed_files_size: allowedFilesSize !== null && allowedFilesSize !== void 0 ? allowedFilesSize : _utils.allowedFilesError.allowed_files_size
    });

    return (0, _preact.h)("span", {
      key: filename
    }, filename, ": ", (0, _preact.h)(_phrase.default, {
      m: "Common",
      p: errorPhrase,
      count: phraseParams
    }), (0, _preact.h)("br", null));
  })), (0, _preact.h)(_Close.default, {
    width: 18,
    height: 18,
    className: "content-attachments__error-close",
    onClick: onDismissError
  })), Boolean(attachments.length) && (0, _preact.h)("div", null, (0, _preact.h)("p", {
    className: "content-attachments__counter"
  }, (0, _preact.h)("strong", null, attachments.length, " Attachments")), (0, _preact.h)("ul", {
    className: "content-attachments-list"
  }, attachments.map(function (_ref3, index) {
    var filename = _ref3.filename,
        url = _ref3.url,
        isAvPending = _ref3.isAvPending;
    return (0, _preact.h)(_Attachment.default, {
      filename: filename,
      url: url,
      isAvPending: isAvPending,
      onDelete: function onDelete() {
        return _onDelete(index);
      },
      key: index
    });
  }))));
};

var _default = AttachmentList;
exports.default = _default;